import {
  Box,
  Button,
  Grid,
  Paper,
  Typography,
  Collapse,
  IconButton,
  Tooltip
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { useState } from 'react'
import { PointOfContact } from './forms/types/PointOfContact'

type Props = {
  data?: PointOfContact | any
  onEdit?: () => void
  onClear?: () => void
  disabled?: boolean
}

const LabeledText = ({ label, value }: { label: string; value?: string }) => (
  <Box display="flex" flexDirection="column">
    <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5 }}>
      {label}
    </Typography>
    <Tooltip title={value || '-'}>
      <Typography
        variant="body1"
        noWrap
        sx={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {value || '-'}
      </Typography>
    </Tooltip>
  </Box>
)

const PointOfContactSummary = ({ data, onEdit, onClear, disabled = false }: Props) => {
  const [expanded, setExpanded] = useState(true)

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 2,
        mt: 3,
        mb: 3,
        p: 3,
        backgroundColor: '#f9fafb',
        border: '1px solid #d0d7de', // light gray border
        width: '75%',
        maxWidth: '100%'
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" fontWeight={600}>Point of Contact</Typography>
        <IconButton onClick={() => setExpanded(!expanded)} size="small">
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <LabeledText label="First Name" value={data?.person?.firstName} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <LabeledText label="Last Name" value={data?.person?.lastName} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <LabeledText label="Email" value={data?.person?.email} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <LabeledText label="Phone" value={data?.person?.phone} />
          </Grid>
        </Grid>

        {!disabled && (
          <Box mt={3} display="flex" gap={2}>
            {onEdit && (
              <Button variant="contained" onClick={onEdit}>
                Edit
              </Button>
            )}
          </Box>
        )}
      </Collapse>
    </Paper>
  )
}

export default PointOfContactSummary
